import React from "react"

export default function IntegrationsList(): React.JSX.Element {
  return (
    <div className="p-8 h-full w-full flex flex-col gap-4">
      <h1 className="text-2xl font-bold">Integrations</h1>
      <div className="font-thin">
        <p>Integrate Vibrato with your favorite tools to streamline your workflow and automate your tasks.</p>
      </div>

      <div className="mt-4">
        <h2 className="text-xl font-semibold mb-2">Featured Integration: Zapier</h2>
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="flex items-center mb-4">
            <img src="/zapier-logo.png" alt="Zapier Logo" className="w-36 h-auto mr-4" />
            <h3 className="text-lg font-semibold">Vibrato + Zapier</h3>
          </div>
          <p className="mb-4">
            Connect Vibrato with 5,000+ apps using our Zapier integration. Automate your workflows and save time by
            triggering Vibrato calls based on events in other apps or using Vibrato call data to trigger actions
            elsewhere.
          </p>
          <h4 className="font-semibold mb-2">Why it's useful:</h4>
          <ul className="list-disc list-inside mb-4">
            <li>Automate call creation based on events in other apps</li>
            <li>Trigger actions in other apps when calls are completed</li>
            <li>Seamlessly integrate Vibrato into your existing workflows</li>
            <li>No coding required - easy to set up and use</li>
          </ul>
          <a
            href="https://zapier.com/apps/vibrato/integrations"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-purple-500 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded inline-block"
          >
            Try Vibrato on Zapier
          </a>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold mb-4">Other Integrations</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <IntegrationCard
            name="Python API Client"
            description="Official Python client for the Vibrato API"
            link="https://github.com/vibratolabs/vibrato-python"
            logo="/github-logo.png"
          />
          <IntegrationCard
            name="Vibrato GPT"
            description="Use Vibrato directly from ChatGPT"
            link="https://chat.openai.com/g/g-BsChUhBjC-make-a-phone-call-by-vibrato"
            logo="/chatgpt-logo.png"
          />
          {/* Add more IntegrationCard components for future integrations */}
        </div>
      </div>
    </div>
  )
}

function IntegrationCard({
  name,
  description,
  link,
  logo
}: {
  name: string
  description: string
  link: string
  logo?: string
}) {
  return (
    <div className="bg-white shadow-md rounded-lg p-4">
      <div className="flex items-center mb-2">
        {logo && <img src={logo} alt={`${name} Logo`} className="w-6 h-6 mr-2" />}
        <h3 className="text-lg font-semibold">{name}</h3>
      </div>
      <p className="mb-4">{description}</p>
      <a href={link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700">
        Learn more
      </a>
    </div>
  )
}
